import { render } from "./ReassignVisit.vue?vue&type=template&id=2bbc730f&ts=true"
import script from "./ReassignVisit?vue&type=script&lang=ts&external"
export * from "./ReassignVisit?vue&type=script&lang=ts&external"

import "../ScheduleVisit/ScheduleVisit.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__